import React from 'react';
import { Trans, withTranslation, WithTranslation } from 'react-i18next';

import * as S from 'src/modules/programs/stepComponents/styles';
import stepIcon from 'src/public/img/behavior_group-4.svg';

export const WhyFocusOnBehaviorsStep = withTranslation('cbt')(({ t }: WithTranslation) => (
    <S.ContentRow>
        <S.ContentColumn md={14}>
            <S.StepHeading>{t('week-6.why-focus-on-behaviors.title')}</S.StepHeading>
            <S.StepDescription small>
                <Trans i18nKey={'week-6.why-focus-on-behaviors.description.1'}>
                    Last week, we spent time figuring out how to build flexibility around the
                    thought part of an emotion. This week we are going to focus on the
                    <S.StyledWord> behaviors</S.StyledWord>.
                </Trans>
            </S.StepDescription>
            <S.StepDescription small>
                {t('week-6.why-focus-on-behaviors.description.2')}
            </S.StepDescription>
        </S.ContentColumn>
        <S.ContentColumn md={10}>
            <S.StepIcon large iconUrl={stepIcon} />
        </S.ContentColumn>
    </S.ContentRow>
));
